import { Injectable } from '@angular/core';
import { ButtonCooldownService } from './button-cooldown.service';
import { AuthSessionService } from './auth-session.service';
import { SecondScreenService } from './second-screen.service';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class SessionCleanupService {
  constructor(
    private buttonCooldown: ButtonCooldownService,
    private authSession: AuthSessionService,
    private secondScreen: SecondScreenService,
    private storageService: StorageService,
  ) {}

  cleanUpAndRedirect(options?: { sessionExpiredMessage?: string; screenId?: string }): void {
    const sessionExpiredMessage = options?.sessionExpiredMessage;
    const screenId = options?.screenId;
    this.buttonCooldown.clearAll();
    this.secondScreen.closeManualSignatureOnSessionEnd();
    this.authSession.markLoggedOut();
    try {
      localStorage.removeItem('pdfjs.history');
    } catch {
      /* ignore */
    }
    sessionStorage.removeItem('extRouting');
    sessionStorage.removeItem('extTarget');
    this.storageService.setExtensionDocumentInfo({});
    this.storageService.clearLocalStoragePreservingLanguage();
    if (sessionExpiredMessage) {
      localStorage.setItem('sessionExpiredMessage', sessionExpiredMessage);
    }
    if (screenId) {
      localStorage.setItem('screenId', screenId);
    }
    window.location.href = `${window.location.origin}${window.location.pathname}#/login`;
  }
}
